import {create} from "zustand";
import {getStorage, PERSISTENT_COOKIE_OPTIONS, setStorage} from "./util.store";

const THEME_STORAGE_KEY = "app-theme";
const VALID_THEMES = ["light", "dark"];

const getInitialTheme = () => {
  const stored = getStorage(THEME_STORAGE_KEY);
  if (stored && VALID_THEMES.includes(stored)) {
    return stored;
  }
  return "dark";
};

const applyThemeToDOM = theme => {
  document.documentElement.setAttribute("data-theme", theme);
};

export const useThemeStore = create((set, get) => ({
  theme: getInitialTheme(),

  setTheme: theme => {
    if (!VALID_THEMES.includes(theme)) return;
    applyThemeToDOM(theme);
    setStorage(THEME_STORAGE_KEY, theme, PERSISTENT_COOKIE_OPTIONS);
    set({theme});
  },

  toggleTheme: () => {
    const next = get().theme === "dark" ? "light" : "dark";
    get().setTheme(next);
  },

  initTheme: () => {
    applyThemeToDOM(get().theme);
  },
}));
